module.exports = __webpack_public_path__ + "static/img/pinpai-25.0028bb4e.png";